export const environment = {
  debugMode: true,
  production: false,

  features: {
    webworkers: true,
  },

  appKey:
    window.location.origin === 'https://vendi-dev1.cloudfabric.co.uk' ? '108749bca0762f981fcf3b0d3614f11a'
      : window.location.origin === 'https://vendi-dev2.cloudfabric.co.uk' ? 'f0518ca6bdb26a79f26c0f3bb3a6afdf'
        : 'f7ee95f38603e350710a5b68b30cf239',

  appName: 'Trello Intellect',

  apiRoot: window.location.origin + '/api',
  trelloAuthorizeUrl: 'https://trello.com/1/authorize',
  webOrigin: window.location.origin,

  allowedOrigins: [
    'https://trello.com',
  ],

  endpoints: {
    // auth
    apiToken: '/trello/membership/apiToken',
    memberAccess: '/trello/membership/memberAccess',
    // misc
    cardChat: '/trello/card-chat',
    // reports
    boardStages: '/trello/statistics/board-stages',
    boardStatus: '/trello/statistics/board-status',
    boardSummaryStatistics: '/trello/statistics/board-summary',
    labels: '/trello/statistics/labels',
    lists: '/trello/statistics/lists',
    members: '/trello/statistics/members',
  },

  paths: {
    // callbacks
    onboarding: '/trello/onboarding',
    oauthCallback: '/trello/oauth-callback',
    // misc
    boardButton: '/trello/board-button',
    cardChat: '/trello/card-chat',
    configuration: '/trello/configuration',
    help: '/trello/help',
    home: '/trello/home',
    // reports
    reportBoardSummary: '/trello/reports/board-summary',
    reportBoardSummaryReference: '/trello/reports/board-summary-reference',
    reportCardDetails: '/trello/reports/card-details',
    reportMemberActivity: '/trello/reports/member-activity',
    reportTimeTracking: '/trello/reports/time-tracking',
  }
};
